// gloss
let _fetchToken: (() => Promise<string | null>) | null = null;

export const registerFetchToken = (fn: () => Promise<string | null>) => {
  _fetchToken = fn;
};

export const getRegisteredFetchToken = () => _fetchToken;
